import React from "react";
import { MenuRoot, MenuButton, MenuList, MenuItem } from "@cadenza/ui";

const SetZoom = ({
  label,
  setScale,
  minScale = 0.1,
  maxScale = 10,
  // pass in labels from the app/wrapper
  messages = {},
}) => {
  const {
    reset = "Reset Zoom",
    min = "Minimize",
    max = "Maximize",
    title = "Set Zoom Level",
  } = messages;

  const MINSCALE = minScale >= 1 ? 0.1 : minScale;
  const MAXSCALE = maxScale <= 1 ? 10 : maxScale;
  const MINMID_SCALE = MINSCALE >= 0.5 ? 1 - (1 - MINSCALE) / 2 : 0.5;
  const MAXMID_SCALE = 1 + (MAXSCALE - 1) / 2;

  return (
    <MenuRoot>
      {(api) => (
        <div>
          <MenuButton
            api={api}
            aria-label={title}
            title={title}
            className="btn-nowrap"
            showCaret={true}
          >
            {(label * 100).toFixed(0)}%
          </MenuButton>
          <MenuList api={api}>
            <MenuItem onClick={() => setScale(1)}>{reset}</MenuItem>
            <MenuItem onClick={() => setScale(MINSCALE)}>
              {min} {(MINSCALE * 100).toFixed(0)}%
            </MenuItem>
            <MenuItem onClick={() => setScale(MINMID_SCALE)}>
              {(MINMID_SCALE * 100).toFixed(0)}%
            </MenuItem>
            <MenuItem onClick={() => setScale(1)}>100%</MenuItem>
            <MenuItem onClick={() => setScale(MAXMID_SCALE)}>
              {(MAXMID_SCALE * 100).toFixed(0)}%
            </MenuItem>
            <MenuItem onClick={() => setScale(MAXSCALE)}>
              {max} {(MAXSCALE * 100).toFixed(0)}%
            </MenuItem>
          </MenuList>
        </div>
      )}
    </MenuRoot>
  );
};

export default SetZoom;
